import { Component, OnInit } from '@angular/core';

import 'rxjs/add/operator/catch';

import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
// import { CategoryService } from 'api/category/category.service';
import { BlogcategoryService } from 'api/blogcategory/blogcategory.service';
import { BlogpostService } from 'api/blogpost/blogpost.service';
declare var $: any;
declare var jQuery: any;





@Component({
    selector: 'application-page',
    templateUrl: './blogpost.html',

})

export class Blogpost implements OnInit {

    searchvalue: String;
    totalcategory: number = 0;
    name: String;
    isactive: boolean;
    id: any
    selectedItemCategory = undefined
    url: string
    blogpostList = [];
    categoryList = [];
    category: any
    index: any;
    activeModal: any;

    constructor(private router: Router,

        private blogpostService: BlogpostService,
        private blogcategoryService: BlogcategoryService,
        private route: ActivatedRoute) {

    }

    ngOnInit() {
        this.blogcategoryService.allCategory().then(data => {
            if (data) {
                this.categoryList = data
                this.totalcategory = this.categoryList.length;


            }
            else {
              
            }

        });


        // if (this.searchvalue == undefined) {
        //     this.searchvalue = '';
        // }
        this.blogpostService.allBlogpost1().then(data => {
            if (data) {
                this.blogpostList = data.data
                // this.totalcategory = this.blogpostList.length;



                
            }
            else {

            }

        });




    }



    resetData() {
        this.name = "";
        this.url = "";
        this.selectedItemCategory = undefined
    }




    InsertblogPost() {

        if (this.name == undefined || this.name == "") {
            $.notify({
                message: "Please Enter Name."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });

            return;
        }
        else if (this.selectedItemCategory == undefined || this.selectedItemCategory == "") {
            $.notify({
                message: "Please Enter Name."
            }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });

            return;
        }
        else {



            let category =
            {
                name: this.name,
                url: this.url,
                category: this.selectedItemCategory
            }

            this.blogpostService.iBlogPost(category).then(data => {
                if (data) {




                    if (data.status) {

                        this.totalcategory++;
                        this.blogpostList.push(data.data);

                        $(function () {
                            $('#addblogpost').modal('toggle');
                        });


                        $.notify({
                            message: "Successfully Added"
                        }, {
                                type: 'success',
                                placement: {
                                    from: 'bottom',
                                    align: 'right'
                                },
                                delay: 100,
                                timer: 100
                            });
                    }

                }
            });
        }
    }


    opendetails(category) {

        this.id = category.id

        var blogid = category.id

        this.router.navigate(['blogpostdetail/' + this.id + '/' + blogid]);




    }



}














// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/blogpost/blogpost.page.ts